// ProductType Getters

export const getProductTypeList = state => {
  return state.productTypeList
}

export const getProductTypeInfo = state => {
  return state.productTypeInfo
}

export const getFullProductTypesList = state => {
  return state.fullProductTypesList
}
